<template>
    <div>
        <MenuProducts/>
        <Product_HighCost/>
    </div>
</template>

<script>
    import MenuProducts from "@/components/admin/manage_products/menuproducts/MenuProducts.vue";
    import Product_HighCost from "@/components/admin/manage_products/Product_HighCost.vue";
    export default {
        name: "ProductHighCost",
        components: {
            Product_HighCost,
            MenuProducts
        }
    }
</script>

<style scoped>

</style>
